module.exports = __webpack_public_path__ + "img/logo-ETH-tmp.e2251b59.svg";